let wrapper: HTMLDivElement;

export const setWrapper = (element: HTMLDivElement): void => {
	wrapper = element;
};

export const getWrapper = (): HTMLDivElement | undefined => wrapper;
